import { render, staticRenderFns } from "./BranchListItemSimpleCard.vue?vue&type=template&id=65a7b3d5&scoped=true"
import script from "./BranchListItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./BranchListItemSimpleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a7b3d5",
  null
  
)

export default component.exports